<template>
    <div class="vx-row w-full md:w-2/3 lg:w-1/2">
        <vx-card>
            <!-- Smart banner -->
            <div class="vx-row mt-3">
                <div class="vx-col w-full">
                    <h2 >{{ $t("promoassets.smartbanner.title") }}</h2>
                    <p class="mb-0 whitespace-pre-line">{{ $t("promoassets.smartbanner.subtitle") }}</p>
                </div>
            </div>

            <LabelForm>{{ $t("promoassets.smartbanner.language-select") }}:</LabelForm>
            <vs-select class="border-grey-light xs:w-full sm:w-1/4 mb-4" v-model="language">
                <vs-select-item :key="item.id" :value="item.acronym" :text="item.name" v-for="item in this.languages"/>
            </vs-select>
            <CopyToClipboard :text="smartBanner | htmlspecialchars_decode" />

            <!-- Smart link -->
            <div class="vx-row mt-16">
                <div class="vx-col w-full sm:w-full">
                    <h2 >{{ $t("promoassets.smart-link.title") }}</h2>
                    <p class="whitespace-pre-line">{{ $t("promoassets.smart-link.subtitle") }}</p>
                </div>
            </div>

            <CopyToClipboard :text="smartLink">
                <template v-if="hasSmartLinkValue" #actions>
                    <div
                        class="w-full sm:w-auto"
                        data-testid="promo-qr-section"
                    >
                        <vs-dropdown
                            vs-trigger-click
                            class="xs:w-full sm:w-auto promo-qr-download-dropdown"
                        >
                            <vs-button
                                class="xs:w-full sm:w-auto rounded-lg flex items-center justify-center"
                                data-testid="promo-qr-download-dropdown-trigger"
                                type="filled"
                                :title="$t('promoassets.qr.download-menu-button')"
                                :aria-label="$t('promoassets.qr.download-menu-button')"
                            >
                                <feather-icon icon="DownloadIcon" :svgClasses="'w-5 h-5'" />
                            </vs-button>
                            <vs-dropdown-menu data-testid="promo-qr-dropdown-menu">
                                <vs-dropdown-item @click="downloadQr('svg')">
                                    SVG
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="downloadQr('png')">
                                    PNG
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="downloadQr('jpg')">
                                    JPG
                                </vs-dropdown-item>
                                <vs-divider class="my-1" />
                                <vs-dropdown-item @click="downloadQrZip">
                                    ZIP
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </template>
            </CopyToClipboard>

            <!-- Promo assets -->
            <div class="vx-row mt-16" v-if="urlToDownload.length > 0">
                <div class="vx-col w-full sm:w-full">
                    <h2 >{{ $t("promoassets.title") }}</h2>
                    <p>{{ $t("promoassets.promo-assets.subtitle") }}</p>
                    <vs-button class="xs:w-full sm:w-auto rounded-lg" :href="urlToDownload">
                        {{ $t("promoassets.promo-assets.download") }}
                    </vs-button>
                </div>
            </div>



            <!-- Related articles -->
            <!-- <p class="mt-12">{{ $t("promoassets.related-articles.title") }}</p>
            <p class="mb-1"><a href="">{{ $t("promoassets.related-articles.how-to-promote") }}</a></p>
            <p><a href="">{{ $t("promoassets.elated-articles.how-to-use-smartlink") }}</a></p> -->

        </vx-card>
    </div>
</template>

<script>
import LabelForm from '@/modules/Shared/Components/form/LabelForm'
import CopyToClipboard from '@/modules/Shared/Components/CopyToClipboard'
import LanguageService from '@/modules/Shared/Services/LanguageService'
import PromoAssetsService from '@/modules/Apps/Services/PromoAssetsService'
import AppsService from '@/modules/Apps/Services/AppsService'
import {saveAs} from 'file-saver'
import AdmZip from 'adm-zip'
import {
    createQrExportPayload,
    hasSmartLink
} from '@/modules/Apps/Helpers/promoAssetsQrHelper'
import {slugifyForFilename} from '@/modules/Apps/Helpers/slugifyForFilename'
import {mapGetters} from 'vuex'
export default {
    name: 'promo-asets',
    components: {
        LabelForm,
        CopyToClipboard
    },
    data() {
        return {
            language: null,
            languages: {},
            smartBanner: '',
            smartLink: '',
            urlToDownload: '',
            applicationDisplayName: '',
        }
    },

    computed: {
        ...mapGetters( ['applicationUuid', 'applicationLanguage']),
        hasSmartLinkValue() {
            return hasSmartLink(this.smartLink)
        },
        smartBannerWithLanguage(){
            if(this.smartBanner) {
               return 'exists smartbanner'
            } else {
                return 'not exists smartbanner'
            }
        }
    },
    async created() {
        this.language = this.applicationLanguage
        this.languages = await this.getLanguages()
        await this.getPromoAssets()
        this.changeSmartBannerLanguage()

    },
    watch: {
        language() {
            this.changeSmartBannerLanguage()
        }
    },
    methods: {
        getQrBaseName() {
            const slug = slugifyForFilename(this.applicationDisplayName)
            return slug ? `${slug}-qr` : 'app-qr'
        },
        downloadTextFile(content, fileName, mimeType = 'text/plain;charset=utf-8') {
            const blob = new Blob([content], {type: mimeType})
            saveAs(blob, fileName)
        },
        async createQrPayload() {
            if (!this.hasSmartLinkValue) {
                return null
            }

            return createQrExportPayload(this.smartLink)
        },
        async downloadQr(format) {
            try {
                const qrPayload = await this.createQrPayload()

                if (!qrPayload) {
                    return
                }

                const fileBaseName = this.getQrBaseName()
                const formatToDownload = {
                    svg: () => this.downloadTextFile(qrPayload.svg, `${fileBaseName}.svg`, 'image/svg+xml;charset=utf-8'),
                    png: () => saveAs(qrPayload.pngBlob, `${fileBaseName}.png`),
                    jpg: () => saveAs(qrPayload.jpgBlob, `${fileBaseName}.jpg`)
                }

                const downloadByFormat = formatToDownload[format]

                if (!downloadByFormat) {
                    throw new Error(`Unsupported format: ${format}`)
                }

                downloadByFormat()
            } catch (error) {
                this.$vs.notify({
                    title: this.$t('promoassets.qr.error-title'),
                    text: this.$t('promoassets.qr.error-generation'),
                    color: 'danger'
                })
            }
        },
        async downloadQrZip() {
            try {
                const qrPayload = await this.createQrPayload()

                if (!qrPayload) {
                    return
                }

                const fileBaseName = this.getQrBaseName()
                const zip = new AdmZip()

                zip.addFile(`${fileBaseName}.svg`, qrPayload.svgBytes)
                zip.addFile(`${fileBaseName}.png`, qrPayload.pngBytes)
                zip.addFile(`${fileBaseName}.jpg`, qrPayload.jpgBytes)

                const zipBlob = new Blob([zip.toBuffer()], {type: 'application/zip'})
                saveAs(zipBlob, `${fileBaseName}.zip`)
            } catch (error) {
                this.$vs.notify({
                    title: this.$t('promoassets.qr.error-title'),
                    text: this.$t('promoassets.qr.error-zip'),
                    color: 'danger'
                })
            }
        },
        changeSmartBannerLanguage() {
            this.smartBanner = this.$options.filters.htmlspecialchars_decode(this.smartBanner)
                                .replace(/smartbanner_({language}|\w{2})\.js">/, `smartbanner_${this.language}.js">`)
        },
        async getLanguages() {
            const supportedLanguages = ['en', 'es', 'fr', 'ca', 'it', 'de', 'pt', 'sv', 'sl', 'no', 'sk', 'pl']
            const languages = await LanguageService.getLanguages();
            return languages.filter(language => supportedLanguages.includes(language.acronym))
        },
        async getPromoAssets() {
            const promoAssets = await PromoAssetsService.getPromoAssets(this.applicationUuid)

            this.smartBanner = promoAssets['smartbanner']
            this.smartLink = promoAssets['smartlink']
            this.urlToDownload = promoAssets['others'] ? promoAssets['others'] : this.urlToDownload

            try {
                const appInfoResponse = await AppsService.basicAppInfo(this.applicationUuid)
                const appObject = appInfoResponse && appInfoResponse.data && appInfoResponse.data.object
                const rawName = appObject && (appObject.name || appObject.title)
                this.applicationDisplayName = typeof rawName === 'string' ? rawName : ''
            } catch {
                this.applicationDisplayName = ''
            }
        }

    }

}
</script>
